module.exports = __webpack_public_path__ + "static_pc/img/19.49eb1ace.png";